import React, { useEffect, useState } from "react";
import NavBar from "../../../../components/navbar/NavBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import Tooltip from "@mui/material/Tooltip";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import useLocalWallet from "../../../../utils/hooks";
import Swal from "sweetalert2";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { InitializeToken } from "./InitializeTokenBuy";
import { useAnchorWallet, useWallet } from "@solana/wallet-adapter-react";
import { useSelector } from "react-redux";
import axios from "axios";
import messages from "../../../../constants/messages";
import { PublicKey } from "@solana/web3.js";
import useContractInit from "../../../../utils/hooks/contractInit";
import { Stepper, Step } from "react-form-stepper";
import { Form, InputGroup, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";

const AdminTokenInitialization = () => {
  const {
    isOpen,
    handleRightToggle,
    setIsOpen,
    copyAccountToClipboard,
    copyToClipboard,
    balance,
    connected,
    walletAddress,
  } = useLocalWallet();
  const wallet = useAnchorWallet();
  const { wallet: testWallet } = useWallet();
  const { saleAuthorityAddress, getTokenInitializationDetails } =
    useContractInit();

  const [currentToken, setCurrentToken] = useState(null);
  const [tokenMintedWallet, setTokenMintedWallet] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);
  const steps = ["Step 1", "Step 2"];
  const [errorMessage, setErrorMessage] = useState("");

  const user = useSelector((state) => state.userStore.user);
  const token = user.auth;

  const tokenSaleProgramId = process.env.REACT_APP_TOKEN_SALE_PROGRAM_ID;

  const handleNext = () => {
    const validation = isStep1Valid();
    if (!validation.isValid) {
      setErrorMessage(validation.message);
      return;
    }
    setErrorMessage("");
    setCurrentStep((prevStep) => Math.min(prevStep + 1, steps.length - 1));
  };

  const handleBack = () => {
    setCurrentStep((prevStep) => Math.max(prevStep - 1, 0));
  };

  const isStep1Valid = () => {
    // Check if all fields are filled
    if (
      !monthlyData.every((item) => item.date && item.time && item.tokenQuantity)
    ) {
      return { isValid: false, message: "All fields are required to proceed." };
    }

    if (!monthlyData.every((item) => item.tokenQuantity > 0)) {
      return {
        isValid: false,
        message: "Token quantity must be greater than 0 for all entries.",
      };
    }

    // Convert the monthly data into an array of date objects
    const dateTimeArray = monthlyData.map((item, index) => {
      const date = new Date(item.date);
      const timeParts = item.time.split(":");
      date.setHours(timeParts[0]);
      date.setMinutes(timeParts[1]);
      return { dateTime: date, monthIndex: index };
    });

    // Get the current date and time
    const now = new Date();
    const currentDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const currentTimeInMinutes = now.getHours() * 60 + now.getMinutes();

    // Validate the order of dates and times
    for (let i = 0; i < dateTimeArray.length - 1; i++) {
      const current = dateTimeArray[i];
      const next = dateTimeArray[i + 1];

      if (current.dateTime > next.dateTime) {
        return {
          isValid: false,
          message: `The date for ${months[next.monthIndex]} must be after ${
            months[current.monthIndex]
          }.`,
        };
      } else if (current.dateTime.getTime() === next.dateTime.getTime()) {
        const currentTime =
          current.dateTime.getHours() * 60 + current.dateTime.getMinutes();
        const nextTime =
          next.dateTime.getHours() * 60 + next.dateTime.getMinutes();
        if (currentTime >= nextTime) {
          return {
            isValid: false,
            message: `The time for ${months[next.monthIndex]} must be after ${
              months[current.monthIndex]
            }.`,
          };
        }
      }
      if (current.dateTime.toDateString() === currentDate.toDateString()) {
        const selectedTimeInMinutes =
          current.dateTime.getHours() * 60 + current.dateTime.getMinutes();
        if (selectedTimeInMinutes < currentTimeInMinutes) {
          return {
            isValid: false,
            message: `The time for ${
              months[current.monthIndex]
            } must be after the current time.`,
          };
        }
      }
    }

    return { isValid: true, message: "" };
  };

  const months = [
    "1st Month",
    "2nd Month",
    "3rd Month",
    "4th Month",
    "5th Month",
    "6th Month",
    "7th Month",
    "8th Month",
    "9th Month",
    "10th Month",
    "11th Month",
    "12th Month",
    "13th Month",
    "14th Month",
  ];

  const [monthlyData, setMonthlyData] = useState(
    months.map(() => ({ date: "", tokenQuantity: "" }))
  );
  const [dateArray, setDateArray] = useState([]);
  const [tokenQuantityArray, setTokenQuantityArray] = useState([]);

  const handleMonthlyInputChange = (index, field, value) => {
    const updatedData = [...monthlyData];
    updatedData[index][field] = value;

    const enrichedData = updatedData.map((item) => {
      const formattedTime = item.time ? item.time : "00:00";
      return {
        ...item,
        fullDatetime:
          item.date && item.time ? `${item.date}T${formattedTime}` : "",
      };
    });

    setMonthlyData(enrichedData);
    setDateArray(enrichedData.map((item) => item.fullDatetime));
    setTokenQuantityArray(
      enrichedData.map((item) =>
        item.tokenQuantity ? Number(item.tokenQuantity) : 0
      )
    );

    console.log("updatedData", enrichedData);
    console.log(
      "dateArray",
      enrichedData.map((item) => item.fullDatetime)
    );
    console.log(
      "tokenQuantityArray",
      enrichedData.map((item) => item.tokenQuantity)
    );
  };

  const fetchLatestDeployedAndMintedToken = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_URL}/deployment/getLatestDeployedTokenAdmin`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const latestDeployedTokenAddress =
        response.data.data?.tokenContractAddress || "";
      setCurrentToken(latestDeployedTokenAddress);
      const latestDeployedWallet =
        response.data.data?.deploymentwalletAddress || "";
      setTokenMintedWallet(latestDeployedWallet);
    } catch (error) {
      setCurrentToken("");
      setTokenMintedWallet("");
      Swal.fire({
        title: messages.titles.error,
        text: messages.errors.fetchLatestDeployedAndMintedTokenFailed,
        icon: "error",
        confirmButtonText: messages.buttons.ok,
      });
    }
  };

  useEffect(() => {
    fetchLatestDeployedAndMintedToken();
  }, []);

  useEffect(() => {
    getTokenInitializationDetails();
  }, [saleAuthorityAddress]);

  return (
    <>
      <NavBar />
      <div className={`sidebar-sec ${isOpen === true ? "active" : ""}`}>
        <section id="content-wrapper">
          <h4 className="my-dash main-head">Contract Initialization</h4>
          <div className="running-token">
            {tokenSaleProgramId && <p>Current Program Id : </p>}
            <span>
              {tokenSaleProgramId
                ? `${tokenSaleProgramId.substring(
                    0,
                    4
                  )}...${tokenSaleProgramId.slice(-4)}`
                : ""}

              <Tooltip title="Copy Program Id" arrow>
                <FontAwesomeIcon
                  icon={faCopy}
                  className="copy-wallet-icon"
                  onClick={() => copyToClipboard(tokenSaleProgramId)}
                />
              </Tooltip>
            </span>
          </div>
          <div className="running-token">
            {saleAuthorityAddress && <p>Current Sale Authority : </p>}
            <span>
              {saleAuthorityAddress
                ? `${saleAuthorityAddress.substring(
                    0,
                    4
                  )}...${saleAuthorityAddress.slice(-4)}`
                : ""}

              {saleAuthorityAddress && (
                <Tooltip title="Copy Sale Authority Address" arrow>
                  <FontAwesomeIcon
                    icon={faCopy}
                    className="copy-wallet-icon"
                    onClick={() => copyToClipboard(saleAuthorityAddress)}
                  />
                </Tooltip>
              )}
            </span>
          </div>
          <div className="user-dashboard">
            <div className="right-sidebar">
              <div className="right-sidebar-inner">
                <nav className="navbar navbar-expand-lg navbar-light">
                  <div className="right-toggle-menu-outer">
                    <div className="right-toggle-menu">
                      <div
                        className="right-toggle-menu-inner"
                        onClick={handleRightToggle}
                      >
                        <div className="wallent">
                          {connected && walletAddress ? (
                            <button className="btn btn-one">
                              {walletAddress.substring(0, 4)}...
                              {walletAddress.slice(-4)}
                            </button>
                          ) : (
                            <button className="btn btn-two">Connect</button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </nav>
                <div
                  className={`right-sidebar ${isOpen === true ? "active" : ""}`}
                >
                  <div className="sd-header">
                    <div className="sd-header-btn" onClick={handleRightToggle}>
                      <i className="fa fa-times"></i>
                    </div>
                  </div>
                  <div className="sd-body">
                    <div className="row">
                      <div className="col-lg-12 col-sm-12">
                        <div className="connect-card">
                          <div className="card-body">
                            <div className="card-inner">
                              <div className="wallet-ui">
                                <div className="wallet-add">
                                  <h6
                                    className={`wallet-address ${
                                      connected && walletAddress
                                        ? "wallet-connected"
                                        : "wallet-disconnected"
                                    }`}
                                  >
                                    {connected && walletAddress
                                      ? "Wallet Address "
                                      : ""}
                                    {connected && walletAddress
                                      ? `${walletAddress.substring(
                                          0,
                                          4
                                        )}...${walletAddress.slice(-4)}`
                                      : "Wallet not connected"}
                                  </h6>
                                  {connected && walletAddress ? (
                                    <Tooltip title="Copy Wallet Address" arrow>
                                      <FontAwesomeIcon
                                        icon={faCopy}
                                        className="admin-lfc-deposit-copy"
                                        onClick={copyAccountToClipboard}
                                      />
                                    </Tooltip>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="admin-lfc-deposit-balance">
                                  {connected ? (
                                    <p>Balance: {balance} SOL</p>
                                  ) : (
                                    <p>Balance: 0 SOL</p>
                                  )}
                                </div>
                                <WalletMultiButton />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`sidebar-overlay ${
                    isOpen === true ? "active" : ""
                  }`}
                  onClick={handleRightToggle}
                ></div>
              </div>
            </div>
            <div className="wizard-container">
              <Stepper activeStep={currentStep}>
                {steps.map((label, index) => (
                  <Step key={index} label={label} />
                ))}
              </Stepper>
              {errorMessage && (
                <div className="error-message validation-error">
                  Note: {errorMessage}
                </div>
              )}

              <div className="step-content userform-step-form">
                {currentStep === 0 && (
                  <div>
                    <h4>Monthly Token Release</h4>
                    {months.map((month, index) => (
                      <div
                        key={index}
                        className="user-dash-tab-form admin-coin-initialization"
                      >
                        <Form.Label>{month}</Form.Label>
                        <InputGroup className="">
                          <DatePicker
                            selected={
                              monthlyData[index].date
                                ? new Date(monthlyData[index].date)
                                : null
                            }
                            onChange={(date) => {
                              handleMonthlyInputChange(
                                index,
                                "date",
                                date ? date.toLocaleDateString("en-CA") : ""
                              );
                              setErrorMessage("");
                            }}
                            dateFormat="MM-dd-yyyy"
                            className="form-control datepiker-box"
                            placeholderText={`Select Date for ${month}`}
                            minDate={new Date()}
                          />
                          <Form.Control
                            type="time"
                            name={`time-${month}`}
                            value={monthlyData[index].time || ""}
                            onChange={(e) => {
                              handleMonthlyInputChange(
                                index,
                                "time",
                                e.target.value
                              );
                              setErrorMessage("");
                            }}
                            placeholder={`Select Time for ${month}`}
                            required
                          />
                          <Form.Control
                            type="number"
                            name={`tokenQuantity-${month}`}
                            value={monthlyData[index].tokenQuantity}
                            onChange={(e) => {
                              handleMonthlyInputChange(
                                index,
                                "tokenQuantity",
                                e.target.value
                              );
                              setErrorMessage("");
                            }}
                            placeholder={`Token Quantity for ${month}`}
                            required
                          />
                        </InputGroup>
                      </div>
                    ))}
                  </div>
                )}
                {currentStep === 1 && (
                  <div className="user-dashboard-inner">
                    <div className="user-dashboard-tab second-stepper-form">
                      <div className="container">
                        <div className="user-dashboard-tab-inner stepper-inner-secondtab">
                          <Tabs
                            defaultActiveKey="initialize"
                            id="uncontrolled-tab-example"
                            className=""
                          >
                            <Tab
                              eventKey="initialize"
                              title="Buy Contract Initialization"
                            >
                              <div className="user-dash-tab-form">
                                <InitializeToken
                                  wallet={wallet}
                                  isOpen={isOpen}
                                  setIsOpen={setIsOpen}
                                  connected={connected}
                                  tokenAddress={
                                    currentToken
                                      ? new PublicKey(currentToken)
                                      : ""
                                  }
                                  onInitializeSuccess={
                                    getTokenInitializationDetails
                                  }
                                  dateArray={dateArray}
                                  tokenQuantityArray={tokenQuantityArray}
                                  setMonthlyData={setMonthlyData}
                                  months={months}
                                  setCurrentStep={setCurrentStep}
                                  tokenMintedWallet={tokenMintedWallet}
                                />
                              </div>
                            </Tab>
                          </Tabs>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="button-container">
                <button
                  className="back-button"
                  onClick={handleBack}
                  disabled={currentStep === 0}
                >
                  Back
                </button>
                {currentStep !== steps.length - 1 && (
                  <button
                    className="next-button"
                    onClick={handleNext}
                    disabled={!isStep1Valid()}
                  >
                    Next
                  </button>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AdminTokenInitialization;
